import { API, API_GET_ID } from "../../config"


export const GetSingleUser= (id) => {
  return (
    API_GET_ID(API.userbyID,id)
  )
}